import ItemStat from "@/old/api/item/itemstat";

export interface IEnhanceRow {
    level: number;
    statGains: any[];
    breakRate: number;
    jellyUseCount: number;
    gearScoreBonus: number;
}

//  NOTE: rows are addressed as data[level - 1], mirroring the long-standing
//  assumption elsewhere in the item code that enhanceData[i].level === i + 1.
export function maxEnhanceLevel(data: IEnhanceRow[] | null): number {
    if (!data || !data.length) {
        return 0;
    }

    return data[data.length - 1].level;
}

export function clampEnhanceLevel(level: number, max: number): number {
    if (!isFinite(level)) {
        return 0;
    }

    return Math.min(Math.max(Math.trunc(level), 0), Math.max(0, max));
}

export function breakRateAt(data: IEnhanceRow[] | null, level: number, useJelly: boolean): number {
    const r = data && data[level - 1];
    if (!r) {
        return 0;
    }

    if (useJelly && r.jellyUseCount) {
        return 0;
    }

    return r.breakRate;
}

export function breakThreshold(data: IEnhanceRow[] | null, useJelly: boolean): number | null {
    if (!data) {
        return null;
    }

    for (let i = 0; i < data.length; i++) {
        if (breakRateAt(data, i + 1, useJelly) > 0) {
            return data[i].level;
        }
    }

    return null;
}

export function canUseJelly(data: IEnhanceRow[] | null): boolean {
    if (!data) {
        return false;
    }

    return data.some((r) => r.jellyUseCount > 0);
}

export function enhanceStatSetFor(data: IEnhanceRow[] | null, level: number): any | null {
    const r = level > 0 && data && data[level - 1];
    if (!r) {
        return null;
    }

    return ItemStat.joinStatSet(r.statGains, "value");
}
